<template>
    <div class="breadcrumbs">
        <template v-for="(breadcrumb, index) in breadcrumbs">
            <NuxtLink :to="breadcrumb.href" :class="[index === breadcrumbs.length - 1 &&
                'truncate  max-md:max-w-[150px] overflow-hidden whitespace-nowrap',
            ]">
                {{ breadcrumb.label }}
            </NuxtLink>

            <span v-html="`/`" v-if="index !== breadcrumbs.length - 1"></span>
        </template>
    </div>
</template>

<script setup>
const route = useRoute();
const app = useAppStore();
const { t } = useI18n();

const props = defineProps({
    item: {
        type: Object,
        default: () => ({
            label: "",
            href: "",
        }),
    },
    fallbackCity: {
        type: Object,
        default: () => ({
            href: "",
            label: "",
        }),
    },
    withContrast: {
        type: Boolean,
        default: false,
    },
});

const base = {
    href: "/",
    label: t("shared.nav.start"),
};

const root = useRootBreadcrumb(route);

// Get City and City ID's from app store
const city = computed(() =>
    app.cities?.find((city) => city.slug === route.path?.split("/")[2]),
);

const cityPart = computed(() => {
    if (!!props.fallbackCity?.href) {
        return {
            label: props.fallbackCity.label ?? "",
            href: `${props.fallbackCity.href}`,
        };
    }
    if (city.value) {
        return {
            label: city.value?.name ?? "",
            href: `${city.value?.slug}`,
        };
    }

    return null;
});

const breadcrumbs = computed(() => {
    const rawItems = [base, root, cityPart.value, props.item]
        .filter(Boolean)
        .filter(item => !!item?.label && !!item?.href)

    let accumulatedPath = ''
    return rawItems.map((item, index) => {
        const isLast = index === rawItems.length - 1
        const href = item.href

        // If last item is an absolute path not under current accumulated path, skip accumulation
        const isStandalone = isLast && !href.startsWith(`${accumulatedPath}/`)

        if (isStandalone || index === 0) {
            accumulatedPath = href
        } else {
            // Safe join: remove trailing slash from accumulated and leading slash from current
            const [path, suffix] = href.split(/(?=[?#])/)
            const cleanPath = path.replace(/^\/+|\/+$/g, '')
            accumulatedPath = `${accumulatedPath.replace(/\/+$/, '')}/${cleanPath}`
            if (suffix) accumulatedPath += suffix
        }

        return {
            ...item,
            href: accumulatedPath,
        }
    })
})

useBreadcrumbsSchema(breadcrumbs.value);
</script>
